import dayjs from '../../../utils/dayjsConfig'
import {
  DAILY_NAVIGATOR_CONFIG,
  DAILY_NAVIGATOR_TEXT
} from '../constants/singleDayNavigatorConstants'

// Devuelve el prefijo de hoy o ayer según la fecha operativa recibida del servidor.
export function getDailyDatePrefix(date, today) {
  switch (date) {
    case today:
      return DAILY_NAVIGATOR_TEXT.TODAY_PREFIX
    case dayjs(today).subtract(1, 'day').format(DAILY_NAVIGATOR_CONFIG.DATE_FORMAT):
      return DAILY_NAVIGATOR_TEXT.YESTERDAY_PREFIX
    default:
      return ''
  }
}

// Arma la etiqueta del día e incluye el año cuando difiere del año de la fecha operativa.
export function getDailyDateLabel(date, today) {
  const selected = dayjs(date)
  const format =
    selected.year() === dayjs(today).year()
      ? DAILY_NAVIGATOR_CONFIG.SAME_YEAR_FORMAT
      : DAILY_NAVIGATOR_CONFIG.OTHER_YEAR_FORMAT
  return `${getDailyDatePrefix(date, today)}${selected.format(format)}`
}

// Valida que el día elegido exista y no supere la fecha operativa máxima.
export function canSelectDailyDate(value, maximum) {
  return Boolean(value && value.isValid() && !value.isAfter(maximum, 'day'))
}
